import { render, staticRenderFns } from "./ThePreviewFile.vue?vue&type=template&id=19c7408c&scoped=true"
import script from "./ThePreviewFile.vue?vue&type=script&lang=js"
export * from "./ThePreviewFile.vue?vue&type=script&lang=js"
import style0 from "./ThePreviewFile.vue?vue&type=style&index=0&id=19c7408c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7408c",
  null
  
)

export default component.exports